import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the Terms and Conditions view.
 * @extends JetView
 */
export default class TermsAndConditionsView extends JetView {
    /**
     * Configures the view layout and data fetching.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        let termsAndConditionsArray = []; // Array to hold terms and conditions data

        // Fetching terms and conditions from the API
        webix.ajax().get(devConfig.geturlApi() + 'Setting/GetTermsAndConditions', '', {
            error: function () {
                webix.message('Error! '); // Error message on API failure
            },
            success: function (text) {
                var resp = JSON.parse(text); // Parsing the response text
                if (!resp.HasError) {
                    // Checking for errors in the response
                    termsAndConditionsArray = resp.Data; // Storing the data
                    let termsRows = []; // Array to hold formatted terms rows

                    // Checking if terms and conditions data is available
                    if (termsAndConditionsArray != undefined && termsAndConditionsArray.length > 0) {
                        // Formatting each term item
                        termsAndConditionsArray.forEach((item) => {
                            let parentsRows = []; // Array for parent rows
                            item.parent.forEach((item2) => {
                                parentsRows.push({
                                    header: item2.title, // Parent title
                                    body: {
                                        view: 'template', // Template view for content
                                        template: item2.content, // Content of the template
                                        autoheight: true, // Auto height adjustment
                                    },
                                });
                            });
                            termsRows.push({
                                header: item.title, // Title of the term
                                body: {
                                    cols: [
                                        { width: 10 }, // Spacer
                                        {
                                            rows: [
                                                { height: 10 }, // Spacer
                                                {
                                                    multi: true, // Allow multiple open items
                                                    view: 'accordion', // Accordion view for collapsible sections
                                                    type: 'clear', // Clear type for styling
                                                    collapsed: true, // Start collapsed
                                                    rows: parentsRows, // Rows containing parent items
                                                },
                                                { height: 10 }, // Spacer
                                            ],
                                        },
                                        { width: 10 }, // Spacer
                                    ],
                                },
                            });
                        });
                        // Adding the terms rows to the main view
                        $$('tyc').addView({
                            multi: true, // Allow multiple open items
                            collapsed: true, // Start collapsed
                            view: 'accordion', // Accordion view
                            type: 'clear', // Clear type for styling
                            rows: termsRows, // Rows containing terms
                        });
                    }
                }
            },
        });
        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            view: 'form', // Main view type
            rows: [
                {
                    view: 'toolbar', // Toolbar for the header
                    css: theme, // Applying the theme
                    elements: [
                        {
                            view: 'label', // Label for the title
                            label: _('Términos y condiciones'), // Localized title
                            align: 'center', // Center alignment
                        },
                    ],
                },
                {
                    view: 'scrollview', // Scrollable view for content
                    scroll: 'y', // Vertical scrolling
                    body: {
                        type: 'wide', // Wide type for layout
                        cols: [
                            { width: 10 }, // Spacer
                            {
                                type: 'wide', // Wide type for inner content
                                id: 'tyc', // ID for the terms container
                                rows: [{ height: 10 }], // Initial spacer row
                            },
                            { width: 10 }, // Spacer
                        ],
                    },
                },
            ],
        };
    }
}

// FILE DOCUMENTED
